export const cTipoRol = {
    humano: 3001,
    api: 3002
}
